import React from "react";
import { SectionSmall, SectionBig } from "../components/Usage.jsx"
import Do1 from '../img/dd_do1.png';
import Dont2 from '../img/dd_dont_2.png';
import Do3 from '../img/dd_do3.png';
import Dont3 from '../img/dd_dont_3.png';
import Dont4 from '../img/dd_dont_4.png';
import Do2 from '../img/dd_do2.png'; 
import Caution1 from '../img/dd_caution_1.png';
//import Do1 from '../img/dd_do1.png';
//import Do1 from '../img/dd_do1.png';
//import Do1 from '../img/dd_do1.png';
//import DoDont from '../components/DoDont.js';


const UsagePage = () => {

    var intro = [
        {
            key: "1",
            title: "Do",
            color: "#4CAF50",
            description: "Wear the Floating Action Bag as a single item. It creates a nice clean look, that is not distracting too much.",
            imgSrc: Do1,
        },

        {
            key: "2",
            title: "Don't",
            color: "#D32F2F",
            description: "Don't clutter the User with other bags. It will make it look weird and creates an uneven style.",
            imgSrc: Dont2,
        },
    ];

    var big1 = [
        {
            key: "3",
            title: "Do",
            color: "#4CAF50",
            description: "Wear the Floating Action Bag over either shoulder. Make sure to always wear it over at least one shoulder to the front.",
            imgSrc: Do3,
        },
    ];

    var mid1 = [
        {
            key: "6",
            title: "Don't",
            color: "#D32F2F",
            description: "Never wear the Floating Action Button on your back. It will make it harder for the User to access it.",
            imgSrc: Dont3,
        },

        {
            key: "7",
            title: "Don't",
            color: "#D32F2F",
            description: "The Floating Action Bag is not a handbag. The long shoulderstrap will become obsolete and is not fit to be held by hand.",
            imgSrc: Dont4,
        },
    ];

    var mid2 = [
        {
            key: "8",
            title: "Do",
            color: "#4CAF50",
            description: "Material You is all about the User's personality. The Color Tool helps to personalize and find a matching color for the User. ",
            imgSrc: Do2,
        },

        {
            key: "9",
            title: "Caution",
            color: "#F9A825",
            description: "Occasionally white can be used to complete the look or give a contrast. However, just because the User has a lazy personality does not mean he has to go without color!",
            imgSrc: Caution1,
        },
    ];


    return (
        <main className="Content" style={{
            height: 'calc(100vh - 36pt)',
            maxHeight: 'calc(100vh - 6vmin)',
            minWidth: '100%',
            overflowY: 'scroll'
        }}>
            <SectionSmall data={intro} />
            <br/>
            <br/>
            <SectionBig data={big1} />
            <SectionSmall data={mid1} />
            <br/>
            <br/>
            <SectionSmall data={mid2} />
            <br/>
            <br/>
            <br/>
            <br/>
        </main>
    );
};

export default UsagePage;